import { type Framework } from '@toeverything/infra';

import { DefaultServerService } from '../cloud';
import { WorkspaceScope } from '../workspace';
import { WorkspaceCitationStore } from './workspace-citation-store';

export {
  citationFileExtension,
  type CitationStyle,
  formatCitations,
} from './citation-formatters';
export { useWorkspaceCitations } from './use-workspace-citations';
export { WorkspaceCitationStore } from './workspace-citation-store';

/**
 * Register the WorkspaceCitationStore at workspace scope. Must be
 * called from the root framework configurator alongside
 * `configureOrchestrationModule`.
 */
export function configureCitationsModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspaceCitationStore, [DefaultServerService]);
}
